import { useEffect, useState } from "react";
import CredentialVaultAPI from "../api/CredentialVaultAPI";

const useCredentialNotificationRecipients = () => {
	const [emails, setEmails] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;

		(async () => {
			setLoading(true);
			setError(null);

			try {
				const result = await CredentialVaultAPI.getRecipients();
				if (!cancelled) setEmails(result?.emails || []);
			} catch (err) {
				if (!cancelled) setError(err.message);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, []);

	const save = async (nextEmails) => {
		const previous = emails;
		setEmails(nextEmails);

		try {
			const result = await CredentialVaultAPI.saveRecipients(nextEmails);
			setEmails(result?.emails || nextEmails);
			return { success: true };
		} catch (err) {
			setEmails(previous);
			return { success: false, error: err.message };
		}
	};

	return { emails, loading, error, save };
};

export default useCredentialNotificationRecipients;
